import { api, mutate } from "../api/client";
import type { ExpenseInput, PotContributionInput, PotExchangeInput } from "@/server/expenses";

export type ExpenseFormInput = Omit<ExpenseInput, "amount" | "splits"> & {
  amount: string;
  splits: { memberId: string; shareAmount: string }[];
};
export type PotContributionFormInput = Omit<PotContributionInput, "amount"> & { amount: string };
export type PotExchangeFormInput = Omit<PotExchangeInput, "fromAmount" | "toAmount"> & {
  fromAmount: string;
  toAmount: string;
};

export const createExpenseAction = (tripId: string, input: ExpenseFormInput) =>
  mutate(() => api.post(`/api/trips/${tripId}/expenses`, input));

export const updateExpenseAction = (expenseId: string, tripId: string, input: ExpenseFormInput) =>
  mutate(() => api.patch(`/api/trips/${tripId}/expenses/${expenseId}`, input));

export const deleteExpenseAction = (expenseId: string, tripId: string) =>
  mutate(() => api.del(`/api/trips/${tripId}/expenses/${expenseId}`));

export const addPotContributionAction = (
  tripId: string,
  memberId: string,
  input: PotContributionFormInput
) => mutate(() => api.post(`/api/trips/${tripId}/members/${memberId}/pot-contributions`, input));

export const deletePotContributionAction = (contributionId: string, tripId: string) =>
  mutate(() => api.del(`/api/trips/${tripId}/pot-contributions/${contributionId}`));

export const addPotExchangeAction = (tripId: string, input: PotExchangeFormInput) =>
  mutate(() => api.post(`/api/trips/${tripId}/pot-exchanges`, input));

export const deletePotExchangeAction = (exchangeId: string, tripId: string) =>
  mutate(() => api.del(`/api/trips/${tripId}/pot-exchanges/${exchangeId}`));
